// Configuración central de la aplicación
export const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://backend-escuela-n7lb.onrender.com";

export const CATEGORIAS = [
  "Prebenjamín",
  "Benjamín",
  "Alevín",
  "Infantil",
  "Cadete",
  "Juvenil",
  "Senior",
];

export const DEPORTES = [
  { value: "futbol sala", label: "Fútbol Sala" },
  { value: "volley", label: "Volley" },
];

export const LETRAS = ["A", "B", "C", "D", "E"];

export const POSICIONES = ["Portero", "Ala", "Cierre", "Pivot"];

export const deporteLabel = (value) =>
  DEPORTES.find((d) => d.value === value)?.label || value || "—";
